import { useEffect, useState } from 'react';
import { t } from 'i18next';
import { useAPICall } from '../../../hooks';
import { LoggerService, UTCToLocal, dateTimeToCustomFormat } from '../../../ui/utils';
import { DynamicObjectInterface } from '../../../sdk/type';
import CampaignService from '../../../sdk/services/campaignService';
import MDMSService from '../../../sdk/services/mdmsService';
import { DropDownData } from '../../../ui/components/Form/DropDown/types/propsType';
import { Button, ButtonStyles, DropDown, MLPVersion } from '../../../ui/components';
import styles from './index.module.scss';

interface Campaign {
  title: string;
  value: string;
}

export interface ProjectSponsorPropsType {
  title: string;
  name?: string;
}

export const ProjectSponsor = (props: ProjectSponsorPropsType) => {
  const apiCall = useAPICall();
  // const { adminToast } = useAdminToast();

  const [campaignList, setCampaignList] = useState<DropDownData[]>([]);
  const [selectedCampaignValue, setSelectedCampaignValue] = useState<Campaign>(
    campaignList.length > 0
      ? { title: campaignList[0].title as string, value: campaignList[0].value as string }
      : { title: '', value: '' },
  );
  //const [personalAboLastClicked, setPersonalAboLastClicked] = useState<String | undefined>();
  const [recalculateLastClicked, setRecalculateLastClicked] = useState<String | undefined>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchCampaignList();
    if (selectedCampaignValue.value !== '') {
      fetchLastCampaignPointCountDate();
    }
  }, []);

  useEffect(() => {
    if (selectedCampaignValue.value !== '') {
      fetchLastCampaignPointCountDate();
    }
  }, [selectedCampaignValue]);

  useEffect(() => {
    if (campaignList.length > 0) {
      setSelectedCampaignValue({
        title: campaignList[0].title as string,
        value: campaignList[0].value as string,
      });
    }
  }, [campaignList]);

  const fetchLastCampaignPointCountDate = async () => {
    const result = await apiCall(MDMSService.getLastPointCountDate, `${selectedCampaignValue.value}`);
    // let personal = dateTimeToCustomFormat(
    //   UTCToLocal(result?.data?.lastUpdateList[0]?.lastUpdate).toString(),
    //   'DD/MM/YYYY HH:mm',
    // );
    let recalculate = dateTimeToCustomFormat(
      UTCToLocal(result?.data?.lastUpdateList[0]?.lastUpdate).toString(),
      'DD/MM/YYYY HH:mm',
    );
    //setPersonalAboLastClicked(personal.toString());
    setRecalculateLastClicked(recalculate.toString());
  };

  const fetchCampaignList = async () => {
    const result = await apiCall(CampaignService.getAllCampaigns);
    if (result.status === 200 && result?.data?.data?.length > 0) {
      const campaigns = result.data.data.filter(
            (campaign: DynamicObjectInterface) => 
              campaign.status !== 'DELETED' &&
              campaign.status !== 'CLOSED' &&
              campaign.campaignType === 'CHALLENGE' 
        ).map((campaign: DynamicObjectInterface) => ({
        title: `${campaign.campaignId} - ${campaign.campaignName}`,
        value: campaign.campaignId,
      }));
      setCampaignList(campaigns);
    } else {
      LoggerService.log('Failed to retrieve coach list by campaign');
    }
  };

  // const getAboSponsorData = async () => {
  //   const result = await apiCall(MDMSService.getAboSponsorData, selectedCampaignValue?.value!);
  //   if (result.status === 200) {
  //     setIsLoading(false);
  //     // let utcDate = moment.utc(result.data.lastUpdateDate).format('YYYY-MM-DD HH:mm:ss');
  //     let utcDate = dateTimeToCustomFormat(UTCToLocal(result.data.lastUpdateDate).toString(), 'DD/MM/YYYY HH:mm');
  //     // let utcDate = new Date(result.data.lastUpdateDate).toISOString();
  //     setPersonalAboLastClicked(utcDate.toString());
  //   } else {
  //     LoggerService.log('Failed to retrieve personal sponsor ABO');
  //   }
  //   alert(
  //     result.status === 200
  //       ? 'Backend process completed.'
  //       : 'Failed to retrieve personal sponsor ABO. Please try again.',
  //   );
  // };

  const getUpdatePointData = async () => {
    const result = await apiCall(MDMSService.getUpdatePointData, selectedCampaignValue?.value!);
    if (result.status === 200) {
      setIsLoading(false);
      // let utcDate = moment.utc(result.data.lastUpdateDate).format('YYYY-MM-DD HH:mm:ss');
      let utcDate = dateTimeToCustomFormat(UTCToLocal(result.data.lastUpdateDate).toString(), 'DD/MM/YYYY HH:mm');
      setRecalculateLastClicked(utcDate.toString());
    } else {
      LoggerService.log('Failed to run the task.');
    }
    alert(result.status === 200 ? result.data.message : 'Failed to run the task. Please try again.');
  };

  return (
    <div className={styles['backend-process-container']}>
      <div className={styles['title-text-container']}>
        <div className={styles['top-title']}>
          This interface facilitates the execution of a background program responsible for calculating coach and leader
          results.
        </div>
        <div className={styles['bottom-title']}>
          Please note that due to the substantial volume of data and the complexity of calculations involved, the
          processing time is extensive. It is advisable to execute this program after regular working hours.
        </div>
      </div>

      <div className={styles['coach-list-top']}>
        <DropDown
          name="campaignId"
          dropdownLabel={`${t('admin.teams.campaign')}`}
          disabledFilter={false}
          mlpVersion={MLPVersion.ONE}
          value={selectedCampaignValue.value}
          data={campaignList}
          configData={{
            label: 'title',
            onSelect: (selectedItem: DynamicObjectInterface) => {
              setSelectedCampaignValue(selectedItem);
            },
          }}
          readOnly={false}
        />
      </div>
      <div className={styles['description']}>
        <Button
          buttonStyle={ButtonStyles.OUTLINE}
          title="Leader Enrollment"
          onClick={() => {
            setIsLoading(true);
            getUpdatePointData();
          }}
          disabled={isLoading}
        />
        <div className={styles['label-text']}>Last click: {recalculateLastClicked}</div>
      </div>
      {/* <div className={styles['description']}>
        <Button
          buttonStyle={ButtonStyles.OUTLINE}
          title="Personal Sponsor (To be removed)"
          onClick={() => {
            setIsLoading(true);
            getAboSponsorData();
          }}
          disabled={isLoading}
        />
        <div className={styles['label-text']}>Last click: {personalAboLastClicked}</div>
      </div> */}
    </div>
  );
};
